import Product from "../pages/gm/product/index";
import ProductRecycle from "../pages/gm/product/recycle";
import ProductAdd from "../pages/gm/product/add";
import ProductEdit from "../pages/gm/product/edit";
import ProductView from "../pages/gm/product/view";

import Content from "../pages/gm/content/index";
import ContentWu from "../pages/gm/content/wu";
import ContentList from "../pages/gm/content/list";
import ContentInfo from "../pages/gm/content/info";
import ContentTab from "../pages/gm/content/tab";

import User from "../pages/gm/userextend/index";
import Import from "../pages/gm/userextend/import";

import Single from "../pages/gm/single/index";

import LoginLog from "../pages/gm/loginlog/index";

/**
 * 国美水技术
 */
const routes = [
    {
        sort: 3,
        name: "会员",
        path: "/gm/user",
        component: { template: "<router-view></router-view>" },
        redirect: "/gm/user/manage",
        meta: {
            icon: "el-icon-s-check",
            menu: true
        },
        children: [
            {
                name: "会员管理",
                path: "/gm/user/manage",
                component: User,
                meta: {
                    icon: "el-icon-message",
                    menu: true
                }
            },
            {
                name: "导入会员",
                path: "/gm/user/import",
                component: Import,
                meta: {
                    icon: "el-icon-message",
                    menu: true
                }
            },
            {
                name: "登录日志",
                path: "/gm/loginlog/manage",
                component: LoginLog,
                meta: {
                    icon: "el-icon-message",
                    menu: true
                }

            }
        ]
    },
    {
        sort: 4,
        name: "产品",
        path: "/gm/product",
        component: { template: "<router-view></router-view>" },
        redirect: "/gm/product/manage",
        meta: {
            icon: "el-icon-house",
            menu: true
        },
        children: [
            {
                name: "管理产品",
                path: "/gm/product/manage",
                component: Product,
                meta: {
                    menu: true
                }
            },
            {
                name: "产品回收站",
                path: "/gm/product/recycle",
                component: ProductRecycle,
                meta: {
                    menu: true
                }
            },
            {
                name: "添加产品",
                path: "/gm/product/add",
                component: ProductAdd,
                meta: {
                    menu: false
                }
            },
            {
                name: "产品详情",
                path: "/gm/product/view/:id",
                component: ProductView,
                meta: {
                    menu: false
                }
            },
            {
                name: "编辑产品",
                path: "/gm/product/edit/:id",
                component: ProductEdit,
                meta: {
                    menu: false
                }
            },
            {
                name: "产品目录",
                path: "/gm/product/content/:id",
                component: Content,
                meta: {
                    menu: false
                },
                children: [
                    {
                        name: "无内容",
                        path: "/gm/product/content/wu/:id",
                        component: ContentWu,
                        meta: {
                            menu: false
                        }
                    },
                    {
                        name: "列表",
                        path: "/gm/product/content/list/:id/:cid",
                        component: ContentList,
                        meta: {
                            menu: false
                        }
                    },
                    {
                        name: "单页",
                        path: "/gm/product/content/info/:id/:cid",
                        component: ContentInfo,
                        meta: {
                            menu: false
                        }
                    },
                    {
                        name: "选项卡",
                        path: "/gm/product/content/tab/:id/:cid",
                        component: ContentTab,
                        meta: {
                            menu: false
                        }
                    }
                ]
            }
        ]
    },
    {
        sort: 5,
        name: "其他内容",
        path: "/gm/single",
        component: { template: "<router-view></router-view>" },
        redirect: "/gm/single/manage",
        meta: {
            icon: "el-icon-tickets",
            menu: true
        },
        children: [
            {
                name: "其他内容管理",
                path: "/gm/single/manage",
                component: Single,
            }
        ]
    },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/module-gm.js